export const DEFAULT_ERROR_MESSAGE ="Something went wrong";

export const DELETE_CONFIRMATION  = {
    title:"Action Delete",
    message: " Are you sure you want to delete this item ?"
}